/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Section_Not_ReviewedInputs */

const en_case_section_not_reviewed = /** @type {(inputs: Case_Section_Not_ReviewedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not yet reviewed`)
};

const pt_br2_case_section_not_reviewed = /** @type {(inputs: Case_Section_Not_ReviewedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ainda não revisado`)
};

/**
* | output |
* | --- |
* | "Not yet reviewed" |
*
* @param {Case_Section_Not_ReviewedInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_section_not_reviewed = /** @type {((inputs?: Case_Section_Not_ReviewedInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Section_Not_ReviewedInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_section_not_reviewed(inputs)
	return pt_br2_case_section_not_reviewed(inputs)
});